<crm-single-select
  [options]="options"
  [(selectedItem)]="type"
  (selectedItemChange)="typeChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  optionValue="name"
  [isTemplateCombined]="true"
  [appendTo]="appendTo"
  [filter]="false">
  <ng-template
    #itemTemplate
    let-type="item">
    {{ type?.value | paymentTaskScenarioConditionTypeName }}
  </ng-template>
</crm-single-select>
